var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "b-card-actions",
        {
          attrs: { "action-refresh": "", "show-loading": _vm.fetching },
          on: { refresh: _vm.refreshProductData },
        },
        [
          _c("e-table-nested-rows", {
            attrs: {
              fields: _vm.fieldsTaxParameterInconsistencies,
              items: _vm.getProductGroupedByNcm,
              "nested-list-property": "items",
              "empty-text": "Nenhum NCM sem parâmetro fiscal encontrado",
              fetching: _vm.fetching,
            },
            scopedSlots: _vm._u([
              {
                key: "detail-cell(ean)",
                fn: function (ref) {
                  var item = ref.item
                  return [
                    _c("FormulateInput", {
                      attrs: {
                        type: "label",
                        label: _vm.$t("NCM"),
                        value: item.ncm,
                        name: item.ncm,
                      },
                    }),
                  ]
                },
              },
              {
                key: "nested-cell(ean)",
                fn: function (ref) {
                  var itemNested = ref.itemNested
                  return [_vm._v(" " + _vm._s(itemNested.ean) + " ")]
                },
              },
              {
                key: "detail-cell(productName)",
                fn: function (ref) {
                  var item = ref.item
                  return [
                    _c("FormulateInput", {
                      attrs: {
                        type: "label",
                        label: _vm.$t("Descrição"),
                        value: item.ncmDescription,
                        name: "description_" + item.ncm,
                      },
                    }),
                  ]
                },
              },
              {
                key: "nested-cell(productName)",
                fn: function (ref) {
                  var itemNested = ref.itemNested
                  return [
                    _c("e-product-router-link", {
                      attrs: {
                        "sku-id": itemNested.skuId,
                        "product-id": itemNested.productId,
                        "product-name": itemNested.productName,
                        ean: itemNested.ean,
                      },
                    }),
                  ]
                },
              },
              {
                key: "detail-cell(storeWithStockCount)",
                fn: function (ref) {
                  var item = ref.item
                  return [
                    _vm._v(
                      " " + _vm._s(_vm.$t("Total de produtos") + ":") + " "
                    ),
                    _c("b", [_vm._v(_vm._s(item.items && item.items.length))]),
                  ]
                },
              },
              {
                key: "nested-cell(storeWithStockCount)",
                fn: function (ref) {
                  var itemNested = ref.itemNested
                  return [
                    _vm._v(
                      " " + _vm._s(_vm.$t("Lojas com estoque") + ":") + " "
                    ),
                    _c("b", [_vm._v(_vm._s(itemNested.storeIdentifications))]),
                  ]
                },
              },
            ]),
          }),
          _c("p", [
            _vm._v("Observação: Selecione a linha para visualizar os produtos"),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }